import AuthApi from './AuthApi';
import UserApi from './UserApi';
import TotalApi from './TotalApi';
import TransactionApi from './TransactionApi';
import TreeApi from './TreeApi';
import PromotionsApi from './PromotionsApi';
import BithidePaymentApi from './BithidePaymentApi/BithidePaymentApi';
import PaykassmaApi from './PaykassmaApi/PaykassmaApi';
import StatisticApi from './StatisticApi';
import NotificationsApi from './NotificationsApi';
import SlotsHistoryApi from './SlotsHistoryApi';
import MyStatisticsApi from './MyStatisticsApi/MyStatisticsApi';
import GeneralReportApi from './GeneralReportApi/GeneralReportApi';

class Api {
  constructor(baseUrl = '') {
    this.auth = new AuthApi(baseUrl);
    this.user = new UserApi(baseUrl);
    this.total = new TotalApi(baseUrl);
    this.transaction = new TransactionApi(baseUrl);
    this.tree = new TreeApi(baseUrl);
    this.promotions = new PromotionsApi(baseUrl);
    this.bithidePayment = new BithidePaymentApi(baseUrl);
    this.PaykassmaApi = new PaykassmaApi(baseUrl);
    this.statistic = new StatisticApi(baseUrl);
    this.notifications = new NotificationsApi(baseUrl);
    this.slotsHistory = new SlotsHistoryApi(baseUrl);
    this.myStatistics = new MyStatisticsApi(baseUrl);
    this.generalReport = new GeneralReportApi(baseUrl);
  }
}

export default Api;
